import { FC } from 'react';
import Icon, { IconNames } from 'components/Icon';
import { formatNumberAsCurrency } from 'helpers/utils';

interface Props {
  committed_amount: number;
}

export const AutopilotCounter: FC<Props> = ({ committed_amount }) => {
  const formatted = formatNumberAsCurrency(committed_amount, {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  });

  const chars = formatted.replace('$', '').trim().split('');

  return (
    <div className="autopilot-counter" role="text" aria-label={formatted}>
      <Icon name={IconNames.DollarSign} className="autopilot-counter__dollar-sign" />
      <div className="autopilot-counter__digits">
        {chars.map((char, index) =>
          char === ',' ? (
            <span className="autopilot-counter__comma" key={`comma-${index}`}>
              {char}
            </span>
          ) : (
            <div className="autopilot-counter__digit-box" key={`digit-${index}`}>
              <span className="autopilot-counter__digit">{char}</span>
            </div>
          )
        )}
      </div>
    </div>
  );
};
